import React from 'react';

import { CurrencySymbols } from 'src/constants/currencySymbols';
import { Currencies } from 'src/enums';
import { pluralise, numberToDecimalString } from 'src/utils';

import { B2CRentalUnitOfMeasure } from '../../Enums';
import { LoyaltyProgram } from '../BookingSummary.interface';
import { Line } from '../BookingSummary.style';
import { BookingSummaryLoyaltyPrograms } from '../BookingSummaryLoyaltyPrograms';

import { DateSummary } from './DateSummary';
import { DateSummaryProps } from './DateSummary/DateSummary.interface';

import * as S from './TravelSummary.style';

export interface TravelSummaryProps extends DateSummaryProps {
  reference: string;
  duration?: {
    length: number;
    unit: B2CRentalUnitOfMeasure;
  };
  price?: number;
  currency?: Currencies;
  loyaltyPrograms?: LoyaltyProgram[];
  openBookingDetails?: () => any;
  isMobile?: boolean;
}

export const TravelSummary = ({
  reference,
  duration,
  price,
  currency,
  loyaltyPrograms,
  openBookingDetails,
  isMobile,
  ...dateSummaryProps
}: TravelSummaryProps) => {
  const currencySymbol =
    CurrencySymbols[currency] ?? CurrencySymbols[Currencies.NZD];
  return (
    <S.Container>
      <S.Header isMobile={isMobile}>
        <S.SubContainerWrapper>
          <S.HeaderText>
            BOOKING NUMBER: <S.BookingRef>{reference}</S.BookingRef>
          </S.HeaderText>
        </S.SubContainerWrapper>
      </S.Header>
      <DateSummary {...dateSummaryProps} />
      <S.Footer isMobile={isMobile}>
        <S.SubContainerWrapper>
          <S.FooterText>
            {duration?.length}{' '}
            {pluralise(duration?.unit?.toLowerCase(), duration?.length)} -{' '}
            <S.Price>
              {!isMobile && 'Total: '}
              {currency}
              {currencySymbol}
              {numberToDecimalString(price)}
            </S.Price>
          </S.FooterText>
          <S.BookingDetailButton
            target="_blank"
            onClick={(e) => {
              e.stopPropagation();
              openBookingDetails();
            }}
          >
            Booking details
          </S.BookingDetailButton>
        </S.SubContainerWrapper>
      </S.Footer>
      {!!loyaltyPrograms?.length && (
        <S.LoyaltyProgramContainer>
          <Line />
          <BookingSummaryLoyaltyPrograms loyaltyPrograms={loyaltyPrograms} />
        </S.LoyaltyProgramContainer>
      )}
    </S.Container>
  );
};
